// CityDetails.js
import React, { useRef } from 'react';
import { Upload, ImageIcon } from 'lucide-react';

const CityDetails = ({ cityData, setCityData, isAddingNewCity }) => {
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCityData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match('image.*')) {
        alert('Please select an image file');
        return;
      }
      
      const reader = new FileReader();
      reader.onload = () => {
        setCityData(prev => ({
          ...prev,
          imageUrl: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="bg-gray-900 rounded-xl border max-w-7xl mx-auto border-gray-700 shadow-2xl mb-6 overflow-hidden backdrop-blur-sm transition-all duration-300">
      <div className="p-5 border-b border-gray-800 bg-gradient-to-r from-gray-900 to-gray-800">
        <h2 className="text-xl font-bold text-white flex items-center">
          <span className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-3 py-1.5 rounded-lg mr-2 text-sm font-medium shadow-lg">
            {isAddingNewCity ? 'Add New City' : 'City Details'}
          </span>
        </h2>
      </div>

      <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-300 mb-1.5">City Name*</label>
          <input
            type="text"
            name="cityname"
            value={cityData.cityname}
            onChange={handleChange}
            className="w-full p-3 text-sm rounded-lg border border-gray-700 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
            required
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-300 mb-1.5">Country*</label>
          <input
            type="text"
            name="country"
            value={cityData.country}
            onChange={handleChange}
            className="w-full p-3 text-sm rounded-lg border border-gray-700 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
            required
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-300 mb-1.5">State*</label>
          <input
            type="text"
            name="state"
            value={cityData.state}
            onChange={handleChange}
            className="w-full p-3 text-sm rounded-lg border border-gray-700 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
            required
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-300 mb-1.5">Latitude</label>
          <input
            type="number"
            name="latitude"
            value={cityData.latitude}
            onChange={handleChange}
            className="w-full p-3 text-sm rounded-lg border border-gray-700 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-300 mb-1.5">Longitude</label>
          <input
            type="number"
            name="longitude"
            value={cityData.longitude}
            onChange={handleChange}
            className="w-full p-3 text-sm rounded-lg border border-gray-700 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
          />
        </div>

        <div className="md:col-span-2 space-y-2">
          <label className="block text-sm font-medium text-gray-300 mb-1.5">City Image</label>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleImageUpload}
            accept="image/*"
            className="hidden"
          />
          <div className="flex items-center space-x-3">
            <button
              onClick={() => fileInputRef.current.click()}
              className="bg-gray-800 hover:bg-gray-700 text-white px-4 py-2.5 rounded-lg border border-gray-700 flex items-center transition-all hover:border-indigo-500 text-sm font-medium shadow-sm hover:shadow-indigo-500/20"
            >
              <Upload className="w-4 h-4 mr-2" />
              Upload Image
            </button>
            {cityData.imageUrl && (
              <div className="flex items-center bg-gray-800/50 px-3 py-2 rounded-lg border border-gray-700">
                <ImageIcon className="w-4 h-4 text-indigo-400 mr-2" />
                <span className="text-sm text-gray-300 font-medium">Image uploaded</span>
              </div>
            )}
          </div>
        </div>

        <div className="md:col-span-2 space-y-2">
          <label className="block text-sm font-medium text-gray-300 mb-1.5">Description*</label>
          <textarea
            name="description"
            value={cityData.description}
            onChange={handleChange}
            className="w-full p-3 text-sm rounded-lg border border-gray-700 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all"
            rows="4"
            required
          />
        </div>

        {isAddingNewCity && (
          <div className="md:col-span-2 flex justify-end mt-2">
            <button
              onClick={() => {
                // You'll need to pass handleSubmitAll from MainPage
                // and call it here when the button is clicked
                // For now, this is just a placeholder
                console.log("Submit new city:", cityData);
              }}
              className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-6 py-2.5 rounded-lg font-medium shadow-lg transition-all hover:shadow-indigo-700/30"
            >
              Save City
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CityDetails;
// // CityDetails.js
// import React, { useRef } from 'react';
// import { Upload, Image as ImageIcon } from 'lucide-react';

// const CityDetails = ({ cityData, setCityData, isAddingNewCity }) => {
//   const fileInputRef = useRef(null);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCityData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (!file.type.match('image.*')) {
//         alert('Please select an image file');
//         return;
//       }
      
//       const reader = new FileReader();
//       reader.onload = () => {
//         setCityData(prev => ({
//           ...prev,
//           imageUrl: reader.result
//         }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   return (
//     <div className="bg-gray-800/50 rounded-xl border border-gray-700/50 shadow-lg mb-4 overflow-hidden backdrop-blur-sm">
//       <div className="p-4 border-b border-gray-700/50">
//         <h2 className="text-lg font-bold text-white flex items-center">
//           <span className="bg-indigo-500/10 text-indigo-400 px-2.5 py-1 rounded-md mr-2 text-sm">
//             {isAddingNewCity ? 'Add New City' : 'City Details'}
//           </span>
//         </h2>
//       </div>

//       <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
//         <div className="space-y-2">
//           <label className="block text-xs font-medium text-gray-300 mb-1">City Name*</label>
//           <input
//             type="text"
//             name="cityname"
//             value={cityData.cityname}
//             onChange={handleChange}
//             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
//             required
//           />
//         </div>

//         <div className="space-y-2">
//           <label className="block text-xs font-medium text-gray-300 mb-1">Country*</label>
//           <input
//             type="text"
//             name="country"
//             value={cityData.country}
//             onChange={handleChange}
//             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
//             required
//           />
//         </div>

//         <div className="space-y-2">
//           <label className="block text-xs font-medium text-gray-300 mb-1">State*</label>
//           <input
//             type="text"
//             name="state"
//             value={cityData.state}
//             onChange={handleChange}
//             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
//             required
//           />
//         </div>

//         <div className="space-y-2">
//           <label className="block text-xs font-medium text-gray-300 mb-1">Latitude</label>
//           <input
//             type="number"
//             name="latitude"
//             value={cityData.latitude}
//             onChange={handleChange}
//             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
//           />
//         </div>

//         <div className="space-y-2">
//           <label className="block text-xs font-medium text-gray-300 mb-1">Longitude</label>
//           <input
//             type="number"
//             name="longitude"
//             value={cityData.longitude}
//             onChange={handleChange}
//             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
//           />
//         </div>

//         <div className="md:col-span-2 space-y-2">
//           <label className="block text-xs font-medium text-gray-300 mb-1">City Image</label>
//           <input
//             type="file"
//             ref={fileInputRef}
//             onChange={handleImageUpload}
//             accept="image/*"
//             className="hidden"
//           />
//           <div className="flex items-center space-x-2">
//             <button
//               onClick={() => fileInputRef.current.click()}
//               className="bg-gray-700/50 hover:bg-gray-700/70 text-white px-3 py-1.5 rounded-md border border-gray-600/50 flex items-center transition-all hover:border-indigo-400 text-sm"
//             >
//               <Upload className="w-3 h-3 mr-1.5" />
//               Upload Image
//             </button>
//             {cityData.imageUrl && (
//               <div className="flex items-center">
//                 <ImageIcon className="w-4 h-4 text-gray-400 mr-1" />
//                 <span className="text-xs text-gray-300">Image uploaded</span>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="md:col-span-2 space-y-2">
//           <label className="block text-xs font-medium text-gray-300 mb-1">Description*</label>
//           <textarea
//             name="description"
//             value={cityData.description}
//             onChange={handleChange}
//             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
//             rows="3"
//             required
//           />
//         </div>

//         {isAddingNewCity && (
//           <div className="md:col-span-2 flex justify-end mt-4">
//             <button
//               onClick={() => {
//                 // You'll need to pass handleSubmitAll from MainPage
//                 // and call it here when the button is clicked
//                 // For now, this is just a placeholder
//                 console.log("Submit new city:", cityData);
//               }}
//               className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md transition-colors"
//             >
//               Save City
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CityDetails;

// import React, { useRef } from 'react';
  // import { Upload, Image as ImageIcon } from 'lucide-react';

  // const CityDetails = ({ cityData, setCityData }) => {
  //   const fileInputRef = useRef(null);

  //   const handleChange = (e) => {
  //     const { name, value } = e.target;
  //     setCityData(prev => ({
  //       ...prev,
  //       [name]: value
  //     }));
  //   };

  //   const handleImageUpload = (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       if (!file.type.match('image.*')) {
  //         alert('Please select an image file');
  //         return;
  //       }
        
  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         setCityData(prev => ({
  //           ...prev,
  //           imageUrl: reader.result
  //         }));
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   };

  //   return (
  //     <div className="bg-gray-800/50 rounded-xl border border-gray-700/50 shadow-lg mb-4 overflow-hidden backdrop-blur-sm">
  //       <div className="p-4 border-b border-gray-700/50">
  //         <h2 className="text-lg font-bold text-white flex items-center">
  //           <span className="bg-indigo-500/10 text-indigo-400 px-2.5 py-1 rounded-md mr-2 text-sm">
  //             City Details
  //           </span>
  //         </h2>
  //       </div>

  //       <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
  //         <div className="space-y-2">
  //           <label className="block text-xs font-medium text-gray-300 mb-1">City Name*</label>
  //           <input
  //             type="text"
  //             name="cityname"
  //             value={cityData.cityname}
  //             onChange={handleChange}
  //             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
  //             required
  //           />
  //         </div>

  //         <div className="space-y-2">
  //           <label className="block text-xs font-medium text-gray-300 mb-1">Country*</label>
  //           <input
  //             type="text"
  //             name="country"
  //             value={cityData.country}
  //             onChange={handleChange}
  //             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
  //             required
  //           />
  //         </div>

  //         <div className="space-y-2">
  //           <label className="block text-xs font-medium text-gray-300 mb-1">State*</label>
  //           <input
  //             type="text"
  //             name="state"
  //             value={cityData.state}
  //             onChange={handleChange}
  //             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
  //             required
  //           />
  //         </div>

  //         <div className="space-y-2">
  //           <label className="block text-xs font-medium text-gray-300 mb-1">Latitude</label>
  //           <input
  //             type="number"
  //             name="latitude"
  //             value={cityData.latitude}
  //             onChange={handleChange}
  //             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
  //           />
  //         </div>

  //         <div className="space-y-2">
  //           <label className="block text-xs font-medium text-gray-300 mb-1">Longitude</label>
  //           <input
  //             type="number"
  //             name="longitude"
  //             value={cityData.longitude}
  //             onChange={handleChange}
  //             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
  //           />
  //         </div>

  //         <div className="md:col-span-2 space-y-2">
  //           <label className="block text-xs font-medium text-gray-300 mb-1">City Image</label>
  //           <input
  //             type="file"
  //             ref={fileInputRef}
  //             onChange={handleImageUpload}
  //             accept="image/*"
  //             className="hidden"
  //           />
  //           <div className="flex items-center space-x-2">
  //             <button
  //               onClick={() => fileInputRef.current.click()}
  //               className="bg-gray-700/50 hover:bg-gray-700/70 text-white px-3 py-1.5 rounded-md border border-gray-600/50 flex items-center transition-all hover:border-indigo-400 text-sm"
  //             >
  //               <Upload className="w-3 h-3 mr-1.5" />
  //               Upload Image
  //             </button>
  //             {cityData.imageUrl && (
  //               <div className="flex items-center">
  //                 <ImageIcon className="w-4 h-4 text-gray-400 mr-1" />
  //                 <span className="text-xs text-gray-300">Image uploaded</span>
  //               </div>
  //             )}
  //           </div>
  //         </div>

  //         <div className="md:col-span-2 space-y-2">
  //           <label className="block text-xs font-medium text-gray-300 mb-1">Description*</label>
  //           <textarea
  //             name="description"
  //             value={cityData.description}
  //             onChange={handleChange}
  //             className="w-full p-2 text-sm rounded-md border border-gray-600/50 bg-gray-700/20 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500/30"
  //             rows="3"
  //             required
  //           />
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // export default CityDetails;